import axios from "axios";
import i18n, { t } from "@/i18n";
import { tDynamic } from "@/i18n/dynamic";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const org = localStorage.getItem("tt_org");
  if (org) config.headers["X-Org-Id"] = org;
  config.headers["Accept-Language"] = i18n.language;
  return config;
});

// Backend errors: prefer stable codes (error.<code>), else the English message used as a catalog key.
export function errorDetail(e) {
  const d = e?.response?.data?.detail;
  if (d && typeof d === "object" && d.code === "insufficient_credits") window.dispatchEvent(new CustomEvent("tt:insufficient-credits", { detail: d }));
  if (d && typeof d === "object" && d.code === "account_not_approved" && window.location.pathname !== "/pending") window.location.assign("/pending");
  if (d == null) return e?.response ? t("Something went wrong. Please try again.") : t("Network error. Check your connection and try again.");
  if (typeof d === "string") return tDynamic(d);
  if (Array.isArray(d)) return t("Some fields are invalid. Please check the form.");
  if (d.code && i18n.exists(`error.${d.code}`)) return t(`error.${d.code}`, d);
  return tDynamic(d.message || d.code || "");
}

export function errorCode(e) {
  const d = e?.response?.data?.detail;
  return d && typeof d === "object" && !Array.isArray(d) ? d.code : null;
}
